import React from "react";

import { Box, Divider, Typography } from "@material-ui/core";
import { FormHeaderProps } from "./types";

const FormHeader: React.FC<FormHeaderProps> = ({
  title,
  subtitle,
  error,
  testId = "form-header",
  showBottomDivider = true,
}) => (
  <Box marginBottom={3}>
    <Box marginBottom={3} data-test={testId}>
      {title && (
        <Typography variant="h1" component="h1" gutterBottom>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography
          color={error ? "error" : "textSecondary"}
          data-test="form-header"
          variant="body1"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
    {showBottomDivider && <Divider />}
  </Box>
);

export default FormHeader;
